
import React, {InputHTMLAttributes} from 'react';

import {AutoSave} from './AutoSave';
import {Input} from './Input';
import {Submit} from './Submit';
import {Textarea} from './Textarea';

type InputWithName = InputHTMLAttributes<object> & {
	name: string;
}

export default {
	AutoSave,
	Submit,
	Textarea,

	Date: (props: InputWithName) => (
		<Input {...props} type='date' />
	),

	Email: (props: InputWithName) => (
		<Input {...props} type='email' />
	),

	Text: (props: InputWithName) => (
		<Input {...props} type='text' />
	),
};
